export default [
  //- レイヤー順調整(背面)
  {
    path: '34.geojson',
    name: '相野々ダム',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '42.geojson',
    name: '長沼・バッコ潟ほか',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '58.geojson',
    name: '蛭藻沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '35.geojson',
    name: '大屋沼・楢沢沼・三丈沼・荒沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '46.geojson',
    name: '田久保沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '01.geojson',
    name: 'ガバ沢沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '52.geojson',
    name: '馬鞍沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '67.geojson',
    name: '明沢沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '14.geojson',
    name: '御沢・金峰沼',
    area: 'all',
    group: 'tameike',
  },

  //- レイヤー順未調整(全面)
  {
    path: '02.geojson',
    name: 'カメコ沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '03.geojson',
    name: 'ダンナ堤・カスケ沼・中野堤・長持123',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '04.geojson',
    name: 'やぶ沢目1・やぶ沢目2',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '05.geojson',
    name: '一の坂沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '06.geojson',
    name: '栄沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '07.geojson',
    name: '横手沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '08.geojson',
    name: '葛ヶ沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '09.geojson',
    name: '岩の沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '10.geojson',
    name: '喜作沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '11.geojson',
    name: '牛沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '12.geojson',
    name: '五郎兵ヱ沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '13.geojson',
    name: '御所野沼,坂水沼,新堤',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '15.geojson',
    name: '桜長根1.2',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '16.geojson',
    name: '山井沢(1)・山井沢(2)・杉ノ沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '17.geojson',
    name: '市の沢沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '18.geojson',
    name: '寺の沢溜池',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '19.geojson',
    name: '七右ヱ門沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '20.geojson',
    name: '小水沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '21.geojson',
    name: '小堤1',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '22.geojson',
    name: '小堤2',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '23.geojson',
    name: '上の山',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '24.geojson',
    name: '上法寺・岩瀬',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '25.geojson',
    name: '城野岡沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '26.geojson',
    name: '新沼・牛首戸沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '27.geojson',
    name: '新堤',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '28.geojson',
    name: '菅生沢・吉ヶ沢・栩ノ木沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '29.geojson',
    name: '西水沢・水沢2',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '30.geojson',
    name: '石高',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '31.geojson',
    name: '石神沢1.2.3.4',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '32.geojson',
    name: '石切沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '33.geojson',
    name: '倉狩沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '36.geojson',
    name: '大沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '37.geojson',
    name: '大沼溜池',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '38.geojson',
    name: '大堤(横手)',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '39.geojson',
    name: '大仏沼・ガズキ沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '40.geojson',
    name: '沢口沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '41.geojson',
    name: '長岡沼・木陰沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '43.geojson',
    name: '塚須沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '44.geojson',
    name: '天狗沢沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '45.geojson',
    name: '田ノ沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '47.geojson',
    name: '田柵沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '48.geojson',
    name: '湯の沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '49.geojson',
    name: '湯の沢溜池(増田)',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '50.geojson',
    name: '二井山西ノ沢・二井山中堤・二井山前堤',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '51.geojson',
    name: '二井山内山',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '53.geojson',
    name: '伯父ヶ沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '54.geojson',
    name: '白石沢沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '55.geojson',
    name: '鉢山（上堤、下堤）',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '56.geojson',
    name: '板ヶ沢沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '57.geojson',
    name: '美佐古沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '59.geojson',
    name: '福島沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '60.geojson',
    name: '兵部ヶ沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '61.geojson',
    name: '弁財天沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '62.geojson',
    name: '北堤',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '63.geojson',
    name: '北野',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '64.geojson',
    name: '朴田沼溜池',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '65.geojson',
    name: '本堂沼',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '66.geojson',
    name: '明永第一・第二',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '68.geojson',
    name: '木ノ根坂1',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '69.geojson',
    name: '鑓見沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '70.geojson',
    name: '林ノ下（2）',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '71.geojson',
    name: '狼沢',
    area: 'all',
    group: 'tameike',
  },
  {
    path: '72.geojson',
    name: '桑ノ木谷地',
    area: 'all',
    group: 'tameike',
  },
];
